import { render, staticRenderFns } from "./MRC_ESS_SvgIcon.vue?vue&type=template&id=5272c1a2&scoped=true&"
import script from "./MRC_ESS_SvgIcon.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_SvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./MRC_ESS_SvgIcon.vue?vue&type=style&index=0&id=5272c1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5272c1a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5272c1a2')) {
      api.createRecord('5272c1a2', component.options)
    } else {
      api.reload('5272c1a2', component.options)
    }
    module.hot.accept("./MRC_ESS_SvgIcon.vue?vue&type=template&id=5272c1a2&scoped=true&", function () {
      api.rerender('5272c1a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_SvgIcon.vue"
export default component.exports